module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<h4>")
    ; __append(escapeFn( locals.title ))
    ; __append("</h4> ")
    ;  if (locals.firstFetchSuccess && locals.collection.length === 0) { 
    ; __append(" <div class=\"no-results\">No ")
    ; __append(escapeFn( locals.title ))
    ; __append(" found.</div> ")
    ;  } else if (locals.collection.length > 0) { 
    ; __append(" <div class=\"row\"> ")
    ;  _.each(locals.collection, function(item) { 
    ; __append(" <div class=\"col-sm-6 col-lg-4\"> <div id=\"item_")
    ; __append(escapeFn( item.id ))
    ; __append("\" class=\"panel\"></div> </div> ")
    ;  }); 
    ; __append(" </div> ")
    ;  } 
    ; __append(" <div id=\"loader\" class=\"loader\"></div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/panel_list/template.ejs
// module id = 860
// module chunks = 1